export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDv5xfPmupzkHIAbT2liArWmfu-EQmNwT8",
  authDomain: "talaera-2c4a2.firebaseapp.com",
  databaseURL: "https://talaera-2c4a2.firebaseio.com",
  projectId: "talaera-2c4a2",
  storageBucket: "talaera-2c4a2.appspot.com",
  messagingSenderId: "88048258746",
  appId: "1:88048258746:web:f76bd25588bb22f7a37c83",
};
